import { isEmpty, redirectToLogin } from "./helper";
const getToken = () => {
  const tokenString = sessionStorage.getItem('token');
  const userToken = JSON.parse(tokenString);
  return userToken?.token
};

const header = () => ({ 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json', 'token': getToken() || sessionStorage.getItem('tokenV2') || "AmxsG7zkJB" })
const fileUploadHeader = () => ({
  'Accept': 'application/json',  // You can include other necessary headers, but omit 'Content-Type'
  'token': getToken() || sessionStorage.getItem('tokenV2') || "AmxsG7zkJB"
});
export const GetRequest = async (url, queryParamsArr = false) => {
  let queryParams = '';
  Object.entries(queryParamsArr).forEach((entry, index, array) => {
    const [key, value] = entry;
    if (index === array.length - 1) {
      queryParams += `${key}=${value}`
    }
    else {
      queryParams += `${key}=${value}&`
    }
  })
  try {
    const response = await fetch(url + queryParams, { headers: header() });
    if (response.status === 401) {
      redirectToLogin()
    }
    return await response.json();
  }
  catch (err) {
    return err;
  }
}

export const GetRequestNoHeader = async (url, queryParamsArr = false) => {
  let queryParams = '';
  Object.entries(queryParamsArr).forEach((entry, index, array) => {
    const [key, value] = entry;
    if (index === array.length - 1) {
      queryParams += `${key}=${value}`
    }
    else {
      queryParams += `${key}=${value}&`
    }
  })
  try {
    const response = await fetch(url + queryParams);
    return await response.json();
  }
  catch (err) {
    return err;
  }
}

export const PostRequest = async (url, postData, options = {}) => {

  try {
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(postData),
      headers: header(),
      signal: options?.signal,
    });
    if (response.status === 401) {
      redirectToLogin()
    }
    return await response.json();
  }
  catch (error) {
    if (error?.name === 'AbortError') {
      throw error
    }
    return error;
  }
}
export const PostRequestForFile = async (url, queryParamsArr = false, postData) => {
  let queryParams = '';
  Object.entries(queryParamsArr).forEach((entry, index, array) => {
    const [key, value] = entry;
    if (index === array.length - 1) {
      queryParams += `${key}=${value}`
    }
    else {
      queryParams += `${key}=${value}&`
    }
  })
  try {
    const response = await fetch(url + queryParams, {
      method: "POST",
      body: postData,
      headers: fileUploadHeader()
    });
    if (response.status === 401) {
      redirectToLogin()
    }
    return await response.json();
  }
  catch (error) {
    return error;
  }
}
export const PostRequestV2 = async (url, postData) => { //to send parameter in url instead of body
  let queryParams = '';
  Object.entries(postData).forEach(entry => {
    const [key, value] = entry;
    queryParams += `${key}=${value}&`
  });
  queryParams = queryParams.length > 0 ? queryParams.slice(0, -1) : queryParams;
  url = `${url}?${queryParams}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: header()
    });
    if (response.status === 401) {
      redirectToLogin()
    }
    return await response.json();
  }
  catch (error) {
    return error;
  }
}

// update function above 
const memoisedPost = () => {
  const cache = new Map();
  const inProgressRequests = new Map();

  return async (...args) => {
    const selector = JSON.stringify(args);

    if (cache.has(selector)) {
      // If the data is already in the cache, return it
      return cache.get(selector);
    }

    // If a fetch is already in progress for the same arguments, wait for it to resolve
    if (inProgressRequests.has(selector)) {
      return inProgressRequests.get(selector);
    }

    let url = args[0];
    let queryParams = '';
    const postData = args[1];

    if (typeof postData !== 'undefined' && Object.keys(postData).length > 0) {
      Object.entries(postData).forEach((entry) => {
        const [key, value] = entry;
        queryParams += `${key}=${value}&`;
      });

      url = `${url}?${queryParams}`;
    }

    // Mark the request as in progress
    const fetchPromise = (async () => {
      const response = await fetch(url, {
        method: 'POST',
        headers: header(),
      });
      if (response.status === 401) {
        redirectToLogin()
      }
      const promisedData = await response.json();
      cache.set(selector, promisedData);
      inProgressRequests.delete(selector); // Remove the request from in progress once it's resolved

      return promisedData;
    })();

    // Save the promise in the in-progress requests map
    inProgressRequests.set(selector, fetchPromise);

    // Wait for the fetch to complete and return the result
    const result = await fetchPromise;

    return result;
  };
};

export const PostRequestCached = memoisedPost();

const memoizedGet = () => {
  const memcache = new Map()
  return async (...args) => {
    const selector = JSON.stringify(args)
    if (memcache.has(selector)) {
      return memcache.get(selector)
    }
    let url = args[0]
    let queryParams = ''
    const postData = args[1]
    if (typeof postData != 'undefined' && !isEmpty(postData)) {
      Object.entries(postData).forEach((entry) => {
        const [key, value] = entry
        queryParams += `${key}=${value}&`
      })
      url = `${url}${queryParams}`
    }
    const response = await fetch(url);
    if (response.status === 401) {
      redirectToLogin()
    }
    const propmisedData = await response.json()
    memcache.set(selector, propmisedData)
    return propmisedData
  }
}
export const GetRequestCached = memoizedGet();
const memoizedGet2 = () => {
  const memcache = new Map()
  return async (...args) => {
    const selector = JSON.stringify(args)
    if (memcache.has(selector)) {
      return memcache.get(selector)
    }
    let url = args[0]
    let queryParams = ''
    const postData = args[1]
    if (typeof postData != 'undefined' && !isEmpty(postData)) {
      Object.entries(postData).forEach((entry, index, entries) => {
        const [key, value] = entry
        queryParams += `${key}=${value}`
        if (index < entries.length - 1) {
          queryParams += '&';
        }
      })
      url = `${url}${queryParams}`
    }
    const response = await fetch(url, { headers: header() });
    if (response.status === 401) {
      redirectToLogin()
    }
    const propmisedData = await response.json()
    memcache.set(selector, propmisedData)
    return propmisedData
  }
}
export const GetRequestCached2 = memoizedGet2();



const memoisedPostWithPayload = () => {
  const cache = new Map()
  return async (...args) => {
    const selector = JSON.stringify(args)
    if (cache.has(selector)) {
      //   console.log('cached')
      return cache.get(selector)
    }
    let url = args[0]
    const postData = args[1]
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: header()
    })
    if (response.status === 401) {
      redirectToLogin()
    }
    const propmisedData = await response.json();
    cache.set(selector, propmisedData);
    return propmisedData;
  }
}
export const PostRequestCachedV2 = memoisedPostWithPayload();
export const callApiForArray = (apiUrl, dataArray) => {
  let successCount = 0;
  let errorCount = 0;

  const promises = dataArray.map(data => {
    return PostRequest(apiUrl, data)
      .then(res => {
        successCount++;
        return res;
      })
      .catch(err => {
        errorCount++;
        // Instead of throwing the error, return it so Promise.all continues
        return err;
      });
  });

  return Promise.all(promises)
    .then(responses => {
      return [responses, successCount, errorCount];
    })
    .catch(err => {
      console.error(`Error count: ${errorCount}`);
      throw err;
    });
};

const memoizedGet3 = () => {
  const memcache = new Map()
  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    if (isCache) {
      const selector = JSON.stringify(args)
      if (memcache.has(selector)) {
        const { data, timestamp, duration } = memcache.get(selector);
        if ((Date.now() - timestamp) > duration) {
          memcache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      let queryParams = ''
      const postData = args[1]
      if (typeof postData != 'undefined' && !isEmpty(postData)) {
        Object.entries(postData).forEach((entry, index, entries) => {
          const [key, value] = entry
          queryParams += `${key}=${value}`
          if (index < entries.length - 1) {
            queryParams += '&';
          }
        })
        url = `${url}${queryParams}`
      }
      const response = await fetch(url, { headers: header() });
      if (response.status === 401) {
        redirectToLogin()
      }
      const propmisedData = await response.json()
      let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
      memcache.set(selector, { data: propmisedData, timestamp: Date.now(), duration: cacheDuration })
      return propmisedData
    } else {
      let url = args[0]
      const postData = args[1]
      return GetRequest(url, postData)
    }
  }
}


export const GetRequestCachedV3 = memoizedGet3();



const memoisedPostWithPayload3 = () => {
  const cache = new Map()
  return async (...args) => {
    let isCache = args?.length > 2 ? args[2] : false
    if (isCache) {
      const selector = JSON.stringify(args)
      if (cache.has(selector)) {
        const { data, timestamp, duration } = cache.get(selector);
        if ((Date.now() - timestamp) > duration) {
          cache.delete(selector);
        } else {
          return data;
        }
      }
      let url = args[0]
      const postData = args[1]
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: header()
      })
      if (response.status === 401) {
        redirectToLogin()
      }
      const propmisedData = await response.json();
      let cacheDuration = args.length > 3 ? args[3] : 30 * 60 * 1000
      cache.set(selector, { data: propmisedData, timestamp: Date.now(), duration: cacheDuration });
      return propmisedData;
    } else {
      let url = args[0]
      const postData = args[1]
      return PostRequest(url, postData)
    }
  }
}

export const PostRequestCachedV3 = memoisedPostWithPayload3();
